import inputDisabled from '../../../../common/algorithms/input-disabled';

const custom = (params) => inputDisabled(params);

export default custom;
